import { IMethod, IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { executeAction } from 'src/helpers/api';
import { logger } from '../../../../../helpers/logger';
import { t } from '../../../../../i18n';
import notifications from '../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { ProcessActionRequestAction } from './actions.d';
import { IActionKeys, IProcessActionResponse } from './types';
import actions from './actions';

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key, loadDataAction } = payload;

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      { url, method, data },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      switch (key) {
        case 'review_all':
          {
            const pendingModalData = result.data?.success?.data;

            if (pendingModalData) {
              const { assessments, experiences, skills } = pendingModalData;

              yield put(actions.loadReviewPendingDataSuccess({ assessments, experiences, skills }));
            }
          }
          break;
        case 'approve':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_approved_successful_text'),
            }),
          );

          if (loadDataAction) {
            yield put(
              actions.processActionRequest({
                url: loadDataAction.url,
                method: loadDataAction.method as IMethod,
                key: loadDataAction.key as IActionKeys,
              }),
            );
          }
          break;
        case 'deny':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_denied_successful_text'),
            }),
          );

          if (loadDataAction) {
            yield put(
              actions.processActionRequest({
                url: loadDataAction.url,
                method: loadDataAction.method as IMethod,
                key: loadDataAction.key as IActionKeys,
              }),
            );
          }
          break;
        default:
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.common.notification.created_successfully', {
                item: t('dash.clients.subUnit.card_label'),
              }),
            }),
          );
          break;
      }

      yield put(actions.processActionSuccess());
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );

      yield put(actions.processActionError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
